export interface TowerDef {
  key: string
  name: string
  emoji: string
  cost: number
  damage: number
  range: number
  fireRate: number // ms between shots
  projectileSpeed: number
  projectileColor: number
  projectileSize: number
  special: 'none' | 'slow' | 'splash' | 'pierce' | 'chain' | 'boost' | 'mega' | 'grenade' | 'rider' | 'boomerang'
  splashRadius?: number
  slowAmount?: number
  slowDuration?: number
  chainCount?: number
  boostRange?: number
  boostMultiplier?: number
  bearColor: number
  tubScale: number // 1.0 = normal, larger = bigger tub footprint
  description: string
}

export const TOWERS: Record<string, TowerDef> = {
  honey: {
    key: 'honey',
    name: 'Honey Bear',
    emoji: '🍯',
    cost: 25,
    damage: 3,
    range: 120,
    fireRate: 1200,
    projectileSpeed: 200,
    projectileColor: 0xFFB300,
    projectileSize: 6,
    special: 'slow',
    slowAmount: 0.4,
    slowDuration: 2000,
    bearColor: 0xFFB300,
    tubScale: 0.8,
    description: 'Throws sticky honey. Slows enemies.',
  },
  salmon: {
    key: 'salmon',
    name: 'Salmon Slinger',
    emoji: '🐟',
    cost: 30,
    damage: 8,
    range: 140,
    fireRate: 900,
    projectileSpeed: 300,
    projectileColor: 0xEF9A9A,
    projectileSize: 5,
    special: 'none',
    bearColor: 0xEF9A9A,
    tubScale: 0.9,
    description: 'Reliable salmon damage. Good all-rounder.',
  },
  barracuda: {
    key: 'barracuda',
    name: 'Barracuda Bear',
    emoji: '🔄',
    cost: 35,
    damage: 5,
    range: 140,
    fireRate: 1600,
    projectileSpeed: 250,
    projectileColor: 0x78909C,
    projectileSize: 6,
    special: 'boomerang',
    bearColor: 0x78909C,
    tubScale: 0.9,
    description: 'Throws boomerang barracuda! Hits enemies going AND coming back.',
  },
  pufferfish: {
    key: 'pufferfish',
    name: 'Pufferfish Bear',
    emoji: '🐡',
    cost: 50,
    damage: 12,
    range: 110,
    fireRate: 1500,
    projectileSpeed: 180,
    projectileColor: 0xFFEE58,
    projectileSize: 8,
    special: 'splash',
    splashRadius: 60,
    bearColor: 0xFFEE58,
    tubScale: 1.0,
    description: 'Lobs pufferfish that explode! AoE damage.',
  },
  swordfish: {
    key: 'swordfish',
    name: 'Swordfish Bear',
    emoji: '🗡️',
    cost: 60,
    damage: 20,
    range: 220,
    fireRate: 2000,
    projectileSpeed: 500,
    projectileColor: 0x90CAF9,
    projectileSize: 4,
    special: 'pierce',
    bearColor: 0x90CAF9,
    tubScale: 1.1,
    description: 'Fires swordfish arrows. Long range, pierces enemies.',
  },
  eel: {
    key: 'eel',
    name: 'Electric Eel Bear',
    emoji: '⚡',
    cost: 70,
    damage: 10,
    range: 130,
    fireRate: 1100,
    projectileSpeed: 400,
    projectileColor: 0x7C4DFF,
    projectileSize: 5,
    special: 'chain',
    chainCount: 3,
    bearColor: 0x7C4DFF,
    tubScale: 1.15,
    description: 'Chain lightning! Zaps up to 3 enemies.',
  },
  catfish: {
    key: 'catfish',
    name: 'Catfish Bear',
    emoji: '🐱',
    cost: 45,
    damage: 0,
    range: 0,
    fireRate: 0,
    projectileSpeed: 0,
    projectileColor: 0x80CBC4,
    projectileSize: 0,
    special: 'boost',
    boostRange: 100,
    boostMultiplier: 1.5,
    bearColor: 0x80CBC4,
    tubScale: 0.85,
    description: 'Support! Boosts nearby towers\' damage by 50%.',
  },
  shark: {
    key: 'shark',
    name: 'Shark Bear',
    emoji: '🦈',
    cost: 150,
    damage: 50,
    range: 160,
    fireRate: 2500,
    projectileSpeed: 350,
    projectileColor: 0x546E7A,
    projectileSize: 12,
    special: 'mega',
    splashRadius: 80,
    bearColor: 0x546E7A,
    tubScale: 1.6,
    description: 'THROWS SHARKS. Massive damage + splash. Expensive.',
  },
  blobfish: {
    key: 'blobfish',
    name: 'Blob Fish Bear',
    emoji: '🫠',
    cost: 200,
    damage: 80,
    range: 180,
    fireRate: 4000,
    projectileSpeed: 120, // slow arc
    projectileColor: 0xE91E63,
    projectileSize: 14,
    special: 'grenade',
    splashRadius: 100,
    bearColor: 0xE91E63,
    tubScale: 1.4,
    description: 'Lobs blob fish grenades in an arc. Massive AoE. Slow but devastating.',
  },
  bass: {
    key: 'bass',
    name: 'Bass Rider',
    emoji: '🐟',
    cost: 40,
    damage: 15,
    range: 0, // doesn't shoot — spawns riders
    fireRate: 2200,
    projectileSpeed: 80, // rider speed on path
    projectileColor: 0x4CAF50,
    projectileSize: 8,
    special: 'rider',
    bearColor: 0x4CAF50,
    tubScale: 0.9,
    description: 'Spawns bass that ride the path toward snowmen! Contact damage.',
  },
}

export const TOWER_ORDER = ['honey', 'salmon', 'barracuda', 'bass', 'pufferfish', 'swordfish', 'eel', 'catfish', 'shark', 'blobfish']
